export default {
  codeView: {
    overflow: 'hidden',
    '& .CodeMirror': {
      height: '100%'
    }
  }
};
